import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Patients
export const getPatients = (search = '', page = 1, pageSize = 50) => {
  const params = { page, page_size: pageSize };
  if (search) {
    params.search = search;
  }
  return axios.get(`${API_URL}/patients`, { params });
};

export const getPatient = (id) => 
  axios.get(`${API_URL}/patients/${id}`);

export const getPatientEvolution = (id) => 
  axios.get(`${API_URL}/patients/${id}/evolution`);

export const createPatient = (data) => 
  axios.post(`${API_URL}/patients`, data);

export const updatePatient = (id, data) => 
  axios.put(`${API_URL}/patients/${id}`, data);

export const updatePatientDiagnoses = (id, diagnoses) => 
  axios.put(`${API_URL}/patients/${id}/diagnoses`, diagnoses);

export const deletePatient = (id) => 
  axios.delete(`${API_URL}/patients/${id}`);

export const savePatientSignature = (id, signature) =>
  axios.put(`${API_URL}/patients/${id}/signature`, { signature });

// Consultations
export const getConsultations = (patientId = null, date = null) => 
  axios.get(`${API_URL}/consultations`, { params: { patient_id: patientId, date } });

export const getConsultation = (id) => 
  axios.get(`${API_URL}/consultations/${id}`);

export const createConsultation = (data) => 
  axios.post(`${API_URL}/consultations`, data);

export const updateConsultation = (id, data) => 
  axios.put(`${API_URL}/consultations/${id}`, data);

export const deleteConsultation = (id) => 
  axios.delete(`${API_URL}/consultations/${id}`);

// Files
export const uploadFile = (consultationId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API_URL}/consultations/${consultationId}/files`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const getConsultationFiles = (consultationId) => 
  axios.get(`${API_URL}/consultations/${consultationId}/files`);

export const getFileUrl = (fileId) => 
  `${API_URL}/files/${fileId}`;

export const downloadFileBlob = async (fileId) => {
  const response = await axios.get(`${API_URL}/files/${fileId}`, {
    responseType: 'blob'
  });
  return response.data;
};

export const deleteFile = (fileId) => 
  axios.delete(`${API_URL}/files/${fileId}`);

// Appointments
export const getAppointments = (date = null) => 
  axios.get(`${API_URL}/appointments`, { params: { date } });

export const getAvailableTimeSlots = (date, excludeId = null) => 
  axios.get(`${API_URL}/appointments/time-slots`, { params: { date, exclude_id: excludeId } });

export const createAppointment = (data) => 
  axios.post(`${API_URL}/appointments`, data);

export const updateAppointmentStatus = (id, status) => 
  axios.put(`${API_URL}/appointments/${id}/status?status=${status}`);

export const deleteAppointment = (id) => 
  axios.delete(`${API_URL}/appointments/${id}`);

// Blocked Days
export const getBlockedDays = (month = null) => 
  axios.get(`${API_URL}/blocked-days`, { params: { month } });

export const blockDay = (date, reason = null) => 
  axios.post(`${API_URL}/blocked-days`, { date, reason });

export const unblockDay = (date) => 
  axios.delete(`${API_URL}/blocked-days/${date}`);

// Predefined data
export const getDiagnoses = () => 
  axios.get(`${API_URL}/diagnoses`);

export const getMedications = () => 
  axios.get(`${API_URL}/medications`);

// Users
export const getUsers = () => 
  axios.get(`${API_URL}/users`);

export const createUser = (data) => 
  axios.post(`${API_URL}/users`, data);

export const updateUser = (id, data) => 
  axios.put(`${API_URL}/users/${id}`, data);

export const deleteUser = (id) => 
  axios.delete(`${API_URL}/users/${id}`);

export const updateUserRole = (id, role) => 
  axios.put(`${API_URL}/users/${id}/role?role=${role}`);

// Settings
export const getSettings = () => 
  axios.get(`${API_URL}/settings`);

export const updateSettings = (data) => 
  axios.put(`${API_URL}/settings`, data);

// Statistics
export const getStatistics = (period = 'month', startDate = null, endDate = null) => {
  const params = { period };
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  return axios.get(`${API_URL}/statistics`, { params });
};

// Lab value extraction from uploaded documents
export const extractLabValues = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API_URL}/extract-lab-values`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
